import { gql } from '@apollo/client'

import { MutationService, getMutationService } from '../../../../helpers/GraphqlHelpers'
import { ForgotPasswordMutation } from '../../../generated/graphql'

export const forgotPassword: MutationService = getMutationService({
  mutation: gql`
    mutation forgotPassword($email: String!) {
      forgotPassword(email: $email)
    }
  `,
  transformer: (response: ForgotPasswordMutation) => {
    return response.forgotPassword
  },
})
